module.exports = __webpack_public_path__ + "static/img/bg-tr.73290084.png";